export default "__VITE_ASSET__4vGA1Df$__"